export default {
  SET_ATTRIBUTES(state, payload) {
    state.EcomAttrinutes = payload;
  },
  SET_SINGLE_ATTRIBUTES(state, payload) {
    state.singleAttrinutesPrime = payload;
  },
  SET_SINGLE_ATTRIBUTES_SEC(state, payload) {
    state.singleAttrinutesSec = payload;
  },
  SET_ON_CLICK_PRODUCT(state, payload) {
    state.onClickProduct = payload;
  },
  SET_ATTRIBUTE_VAL_POPUP(state, payload) {
    state.attributeValPopup = payload;
  },
  SET_ATTRIBUTE_POPUP_OPEN(state, payload) {
    state.attributePopupOpen = payload;
  },
};
